<template>
  <el-dialog
    v-if="isVisible"
    class="serum-dbs-switch-dialog order-test"
    v-model="isVisible"
    title="Feature Not Supported"
    @close="close"
  >
    <div class="dialog-content-container">
      <div>
        <p class="dialog-content-text">{{ description }}</p>
        <AffectedItemsTable from="Current" to="Adjusted" :data="rows">
          <template #header>
            <span class="ml-2 flex">{{ $t("OrderPage[\"Feature\"]") }}</span>
          </template>
        </AffectedItemsTable>      
      </div>
      <div class="flex justify-between mt-9">
        <el-button class="cancel-btn" @click="close">{{ $t("OrderPage[\"Cancel\"]") }}</el-button>
        <el-button class="confirm-btn" @click="proceed">{{ $t("OrderPage[\"Proceed\"]") }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import AffectedItemsTable from "./AffectedItemsTable.vue";
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    AffectedItemsTable
  },
  props: {
    isShowDialog: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isVisible: false,
    }
  },

  computed: {
    ...mapState(["currency"]),
    ...mapState("orderTest/order", ["consultationFee"]),
    ...mapGetters("orderTest/order", ["priceDetails"]),
    ...mapGetters("orderTest/merchandise", ["merchTotalPrice", "selectedMerchList"]),

    rows() {
      const rows = [{
        name: "Payment Method",
        fromPrice: "Patient Pay",
        toPrice: "Provider Bill"
      }]
      if (this.consultationFee 
        && this.consultationFee.isUse 
        && this.consultationFee.amount >0 ) 
      {
        rows.push({
          name: "Consultation Fee",
          fromPrice: `${this.currency.symbol}${this.consultationFee.amount.toFixed(2)}`,
          toPrice: "Discard"
        });
      }
      if (this.priceDetails.markupPrice > 0) {
        rows.push({
          name: "Test Revenue",
          fromPrice: `${this.currency.symbol}${this.priceDetails.markupPrice.toFixed(2)}`,
          toPrice: "Discard"
        });
      }
      if (this.merchTotalPrice > 0) {
        rows.push({
          name: "Practice Product",
          fromPrice: (() => {
            if (this.selectedMerchList.length > 1) {
              return `${this.currency.symbol}${this.merchTotalPrice.toFixed(2)} (${this.selectedMerchList.length} items)`;
            } else {
              return `${this.currency.symbol}${this.merchTotalPrice.toFixed(2)} (${this.selectedMerchList.length} item)`;
            }
          })(),
          toPrice: "Discard"
        });
      }
      return rows;
    },

    description() {
      return this.$t("OrderPage[\"If you choose to proceed, switching to Provider Pay will modify the following features/items:\"]")
    }
  },

  watch: {
    isShowDialog(newVal) {
      this.isVisible = newVal;
    },
  },

  methods: {
    close() {
      this.$emit("close");
    },

    proceed() {
      this.$store.dispatch("orderTest/merchandise/clearAllSelectedMerch");
      this.$emit("proceed");
    },
  },
}
</script>

<style scoped>
.dialog-content-container {
  width: 499px;
}

.dialog-content-text {
  word-break: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}

.cancel-btn {
  height: 42px;
  width: 99px;;
  border-radius: 4px;
  background: #E6E6E6;
  color: #000000;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.43px;
}

.cancel-btn:hover {
  color: #000000;
}

.confirm-btn {
  height: 42px;
  width: 188px;
  border-radius: 4px;
  background-color: #20A8C3;
  color: #FFFFFF;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.43px;
}

.divider-line {
  width: 499px;
  height: 0px;
  border: 1px solid #E6E6E6;
}
</style>